"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const Alphaeon_Patient_Financing_Logo_png_1 = __importDefault(require("images/Alphaeon_Patient_Financing_Logo.png"));
const merchant_portal_components_1 = require("merchant-portal-components");
function HeaderNav({ pushApplicationEnabled, dashboardApplicationEnabled, }) {
    // Hooks
    const loc = (0, react_router_dom_1.useLocation)();
    // State
    const [activeLink, setActiveLink] = (0, react_1.useState)(null);
    const [navScrollHeight, setNavScrollHeight] = (0, react_1.useState)(false);
    //callbacks
    const handleWinScroll = (0, react_1.useCallback)((evt) => {
        const scrollTop = evt.target.scrollingElement.scrollTop;
        if (scrollTop >= 51) {
            if (scrollTop > 100) {
                return;
            }
            setNavScrollHeight(true);
        }
        if (scrollTop <= 10) {
            setNavScrollHeight(false);
        }
    }, [navScrollHeight]);
    const navMap = [
        { url: '/', id: 'nav_dashboard' },
        {
            url: '/account-lookup',
            id: 'nav_account_lookup',
        },
        {
            url: '/application/confirm',
            id: 'nav_apply',
        },
        {
            url: '/sales',
            id: 'nav_transact',
        },
        {
            url: '/calculator',
            id: 'nav_calculator',
        },
        {
            url: '/reports',
            id: 'nav_reports',
        },
        {
            url: '/marketing',
            id: 'nav_marketing',
        },
        {
            url: '/qr-code',
            id: 'nav_marketing',
        },
        {
            url: '/custom-link',
            id: 'nav_marketing',
        },
    ];
    // Funcs
    const updateLocation = (tmpLoc) => {
        const tmpPath = tmpLoc.pathname;
        const newPath = tmpPath.replace('/merchant', '');
        const navId = navMap.filter((itm) => {
            if (itm.url === newPath) {
                return true;
            }
            else {
                // Subpages
                if (itm.url !== '/') {
                    return newPath.includes(itm.url);
                }
            }
        });
        let elemId = '';
        if (tmpPath === '/merchant') {
            navId.push(navMap[0]);
        }
        if (Object.keys(tmpLoc.state) &&
            tmpLoc.state.isTransact &&
            navId.length > 1) {
            elemId = navId[1].id;
        }
        else {
            // Subpages
            if (navId.length) {
                elemId = navId[0].id;
            }
        }
        if (activeLink) {
            if (activeLink === elemId) {
                return; // same link
            }
            const prevNavEl = document.getElementById(activeLink);
            prevNavEl?.classList.remove('active');
        }
        setActiveLink(elemId);
    };
    // Effects
    (0, react_1.useEffect)(() => {
        if (activeLink) {
            const navEl = document.getElementById(activeLink);
            navEl?.classList.add('active');
        }
    }, [activeLink]);
    (0, react_1.useEffect)(() => {
        updateLocation({
            pathname: loc.pathname,
            state: {
                isTransact: loc.state,
            },
        });
    }, [loc]);
    // Init
    (0, react_1.useEffect)(() => {
        document.addEventListener('scroll', handleWinScroll);
        return () => {
            document.removeEventListener('scroll', handleWinScroll);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: `header ${navScrollHeight ? 'nav-height-small' : 'nav-height-big'}`, children: (0, jsx_runtime_1.jsxs)("div", { className: "header__content", children: [(0, jsx_runtime_1.jsx)("div", { className: "header_logo", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: config_1.MERCHANT_PORTAL_URL, children: (0, jsx_runtime_1.jsx)("img", { src: Alphaeon_Patient_Financing_Logo_png_1.default, className: "logo", alt: "Alphaeon Patient Financing logo" }) }) }), (0, jsx_runtime_1.jsxs)("ul", { className: "nav", children: [(0, jsx_runtime_1.jsx)("li", { id: "nav_dashboard", className: "navlink", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: config_1.MERCHANT_PORTAL_URL, children: "Dashboard" }) }), (0, jsx_runtime_1.jsx)("li", { id: "nav_account_lookup", className: "navlink", children: (0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: config_1.ACCOUNT_LOOKUP_URL, requiredPermission: config_1.PERMISSION.ACCOUNT_LOOKUP, children: "Account Lookup" }) }), (dashboardApplicationEnabled === true ||
                                pushApplicationEnabled === true) && ((0, jsx_runtime_1.jsx)("li", { id: "nav_apply", className: "navlink", children: (0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: config_1.START_APPLICATION_URL, requiredPermission: [
                                        config_1.PERMISSION.SUBMIT_DASHBOARD_APPLICATIONS,
                                        config_1.PERMISSION.SUBMIT_PUSH_APPLICATIONS,
                                    ], selectionCriteria: "OR", children: "Apply" }) })), (0, jsx_runtime_1.jsx)("li", { id: "nav_transact", className: "navlink", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: {
                                        pathname: '/merchant/sales/lookup',
                                        state: { isTransact: true },
                                    }, children: "Transact" }) }), (0, jsx_runtime_1.jsx)("li", { id: "nav_calculator", className: "navlink", children: (0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: config_1.CALCULATOR_URL, requiredPermission: config_1.PERMISSION.CALCULATOR, children: "Calculator" }) }), (0, jsx_runtime_1.jsx)("li", { id: "nav_reports", className: "navlink", children: (0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: config_1.REPORT_URL, requiredPermission: [
                                        config_1.PERMISSION.VIEW_APPLICATION_TRACKING_REPORT,
                                        config_1.PERMISSION.VIEW_BANK_RECONCILIATION_REPORT,
                                        config_1.PERMISSION.VIEW_SALE_REPORT,
                                    ], selectionCriteria: "OR", children: "REPORTS" }) }), (0, jsx_runtime_1.jsx)("li", { id: "nav_marketing", className: "navlink right-align", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: config_1.MARKETING_MATERIALS, children: "MARKETING" }) })] })] }) }) }));
}
exports.default = HeaderNav;
